import React, { useEffect, useState } from "react";
import Head from "next/head";
import Link from "next/link";
import Navbar from "../newcomponents/Navbar";
import HeroSection from "../newcomponents/HeroSection";
import ScrollingCompanies from "../newcomponents/ScrollingCompanies";
import DrivenByData from "../newcomponents/DrivenByData";
import HighImpact from "../newcomponents/HighImpact";
import OurProcess from "../newcomponents/OurProcess";
import FaqSimple from "../newcomponents/FaqSimple";
import CallToAction from "../newcomponents/CallToAction";
import Footer from "../newcomponents/Footer";
import Pricing from "../home/Pricing";
import styles from './style.module.css';
import { useAuth } from "@/src/auth";
import { useRouter } from "next/router";
import { homepageFAQ } from "@/data/faq";

const MockPricing = () => {
    const [priceType, setPriceType] = useState<'monthly' | 'quarterly'>('quarterly');
    return (
        <Pricing 
            priceType={priceType}
            handlePriceType={(type) => setPriceType(type as 'monthly' | 'quarterly')}
            freeTrial={false}
            handleClick={() => {}}
            home={true}
        />
    );
};

const homepageDescription = "Let LifeShack's AI find matching jobs and submit applications automatically, so you can spend less time applying and more time interviewing.";

const Newhome = () => {
    const { user } = useAuth();
    const router = useRouter();
  
    useEffect(() => {
        if (!user) return;
        router.push('/candidate/dashboard/auto/');
    }, [router, user]);

    return (
        <div className={styles.container}>
            <Head>
                <title>LifeShack | AI-Powered Job Search</title>
                <meta name="description" content={homepageDescription} />
                <link rel="icon" href="/favicon.ico" />
                <link rel="canonical" href="https://www.lifeshack.com/" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="LifeShack | AI-Powered Job Search" />
                <meta property="og:description" content={homepageDescription} />
                <meta property="og:url" content="https://www.lifeshack.com/" />
                <meta property="og:image" content="https://www.lifeshack.com/widget.png" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="LifeShack | AI-Powered Job Search" />
                <meta name="twitter:description" content={homepageDescription} />
                <meta name="twitter:image" content="https://www.lifeshack.com/widget.png" />
            </Head>
  
            {/* Hero Section */}
            <div className={styles.heroWrapper}>
                <Navbar />
                <HeroSection />
            </div>

            {/* Scrolling Companies */}
            <section className="pt-16 pb-6">
                <ScrollingCompanies />
            </section>

            {/* Stats Section */}
            <section id="stats" className={styles.statsWrapper}>
                <DrivenByData />
            </section>

            {/* Process Section */}
            <section id="process" className="bg-white py-12">
                <OurProcess />
            </section>
        
            {/* High Impact Section */}
            <section className="bg-white pt-20 pb-12">
                <HighImpact />
            </section>
        
            {/* Pricing Section */}
            <section id="plans" className="bg-white py-12">
                <MockPricing />
            </section>
        
            {/* Product research */}
            <section className={styles.researchSection}>
                <div className={styles.researchContent}>
                    <h2 className={styles.researchTitle}>
                        Compare the workflow before you start.
                    </h2>
                    <p className={styles.researchDescription}>
                        See how LifeShack differs from autofill extensions,
                        trackers, browser bots, and other cloud application agents.
                    </p>
                    <div className={styles.researchLinks}>
                        <Link href="/ai-auto-apply/">
                            <a className={styles.researchLink}>
                                Use AI to apply for jobs automatically
                            </a>
                        </Link>
                        <Link href="/best-ai-auto-apply-tools/">
                            <a className={styles.researchLink}>
                                Best AI auto-apply tools
                            </a>
                        </Link>
                        <Link href="/compare/">
                            <a className={styles.researchLink}>
                                Compare LifeShack
                            </a>
                        </Link>
                    </div>
                </div>
            </section>
        
            {/* FAQ Section */}
            <section id="faqs" className="bg-white pt-24 pb-24">
                <FaqSimple questionsAndAnswers={homepageFAQ} noReadMore={true} />
            </section>

            {/* CTA Section */}
            <section className="bg-white pt-12 pb-[102px]">
                <CallToAction />
            </section>

            <Footer />
        </div>
    );
};
  
export default Newhome;
